export default "__VITE_ASSET__CtWW6GOD__"